(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-redesign"] && !Shopify.designMode) return;
  try {
    
function initMyers(root){
if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
const grid=root.querySelector('#catalog'),cards=Array.from(root.querySelectorAll('[data-product-card]')),sort=root.querySelector('.sort'),status=root.querySelector('#result-count');let category='all';
const featured=['trucker-cap-1','trucker-cap','unisex-t-shirt-1','unisex-hoodie'];
const ranks=new Map(cards.map((c,i)=>[c,featured.includes(c.dataset.handle)?featured.indexOf(c.dataset.handle):i+4]));
function update(){let shown=0;const ordered=[...cards].sort((a,b)=>sort.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='high'?Number(b.dataset.price)-Number(a.dataset.price):ranks.get(a)-ranks.get(b));ordered.forEach(card=>{card.hidden=category!=='all'&&card.dataset.category!==category;if(!card.hidden)shown++;grid.append(card)});root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===category)));status.textContent=shown+' '+root.dataset.itemsLabel;}
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;update()}));root.querySelectorAll('[data-category-link]').forEach(a=>a.addEventListener('click',()=>{category=a.dataset.categoryLink;update()}));sort.addEventListener('change',update);update();}
document.querySelectorAll('.mf-redesign').forEach(initMyers);document.addEventListener('shopify:section:load',event=>{initMyers(event.target.querySelector('.mf-redesign'))});

  } catch(e) { console.error(e); }
})();
})();
